import { createSelector } from 'reselect';

export const getComponentState = state => state.adminApparelItemParts;

export const getApparelItemParts = createSelector(
    getComponentState,
    (state) => state.apparelItemParts
);
export const getFetching = createSelector(
    getComponentState,
    (state) => state.fetching
);
export const getIdModal = createSelector(
    getComponentState,
    (state) => state.idModal
);
export const getSizeModal = createSelector(
    getComponentState,
    (state) => state.sizeModal
);
export const getLogoModal = createSelector(
    getComponentState,
    (state) => state.logoModal
);
export const getSaving = createSelector(
    getComponentState,
    (state) => state.saving
);
export const getPagination = createSelector(
    getComponentState,
    (state) => state.pagination
);
export const getApparelItemPart = createSelector(
    getComponentState,
    (state) => state.apparelItemPart
);
export const getIsDeleting = createSelector(
    getComponentState,
    (state) => state.isDeleting
);
export const getSort = createSelector(
    getComponentState,
    (state) => state.sort
);
export const getSearch = createSelector(
    getComponentState,
    (state) => state.search
);
export const getSearchType = createSelector(
    getComponentState,
    (state) => state.searchType
);
export const getItemId = createSelector(
    getComponentState,
    (state) => state.itemId
);
export const getApparelItem = createSelector(
    getComponentState,
    (state) => state.apparelItem
);
export const getIsGenerating = createSelector(
    getComponentState,
    (state) => state.isGenerating
);
export const getSelectedSizes = createSelector(
    getComponentState,
    (state) => state.selectedSizes
);
export const getSelectedLogos = createSelector(
    getComponentState,
    (state) => state.selectedLogos
);